import { render, staticRenderFns } from "./DriverDetailDialog.vue?vue&type=template&id=19e88f06&scoped=true"
import script from "./DriverDetailDialog.vue?vue&type=script&lang=js"
export * from "./DriverDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./DriverDetailDialog.vue?vue&type=style&index=0&id=19e88f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e88f06",
  null
  
)

export default component.exports